module.exports = __webpack_public_path__ + "img/gota-white.11892762.svg";